import { ContactModalContainer } from './containers/ContactModalContainer';

const App = () => (
	<ContactModalContainer />
)

export default App;
